import type { IconSvgObject } from './types';

const AddMaleIcon: IconSvgObject = [
  ["path", { d: "M14 21.0003H2V19.4417C2 18.5808 2.55087 17.8165 3.36757 17.5443L7.99983 16.0003V14.0625C6.21899 12.6687 4.99983 11.0001 4.99983 7.41694C4.99983 3.82709 6.95457 2.00013 9.99214 2.00013C12.1431 2.00013 13.0383 3.00013 13.0383 3.00013C15.5768 3.00013 15.9998 5.09732 15.9998 7.41694C15.9998 11.0001 14.7807 12.6687 12.9998 14.0625V16.0003", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 22L18.5 15M15 18.5H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AddMaleIcon;
